import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollArea = document.querySelector(".scroll-content");
    if (scrollArea) {
      scrollArea.scrollTo({ top: 0 });
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [pathname]);

  return null;
}

export default ScrollToTop;
